import styled from "styled-components";
export const Container = styled.div`
.dateTime {
    height: 35px;
    background-color: #fff;
    width: 35%;
    border: 0.5px solid #CCC;
    color: ${props => props.theme.colors.primaryText};
    border-radius: 17.5px;
    padding: 0 17.5px;
    }
`;
